import styled from 'react-emotion';

export const GroupsListContainer = styled.div`
  height: calc(100vh - 296px);
  margin-right: -20px;
`;

export const GroupList = styled.div`
  margin-right: 20px;
  margin-bottom: 60px;
`;
